export default __webpack_public_path__ + "static/media/cashflow_icon3.5ddbb9d6.svg";